import React from "react";
import { Box, Typography, Avatar } from "@mui/material";
import userD from "../../../assets/customerAssets/user_D.jpeg";
import voteIcon from "../../../assets/customerAssets/freeVotesIcon.svg";
import VideoComoponent from "./VideoComoponent";
import UserVoteComponent from "./UserVoteComponent";

const GoalVideoComponent = ({ data, setTournamentData, index }) => {
  return (
    <>
      <Box className="goal-video-outter">
        <Box className="goal-video-wrapper">
          <Box className="goal-rank-div">
            {/* {data.rank == 1 && <img src={voteIcon} width={40} height={40} />}
            {data.rank} */}
            {index + 1 == 1 && <img src={voteIcon} width={40} height={40} />}
            {index + 1}
          </Box>
          <Box className="video-wrapper ">
            <VideoComoponent
              img={data?.thumbnail}
              duration={data?.duration}
              data={data}
              setTournamentData={setTournamentData}
            />
          </Box>
          <Box className="goal-info-wrapper">
            <Typography component="p">Club: {data?.club}</Typography>
            <Typography component="p">
              Goal Scorer: {data?.goal_scorer}
            </Typography>
            <UserVoteComponent
              id={data.id}
              vote={data.isVoted}
              count={data?.vote}
              setTournamentData={setTournamentData}
            />
          </Box>
          <Box className="goal-votes-wrapper">
            <Avatar
              alt="profile"
              src={
                data?.club_img || data?.goalUserDetails?.profile_img || userD
              }
              sx={{ width: 44, height: 44 }}
            />
            <Box className="votes-wrapper">
              <img src={voteIcon} height={20} width={20} />
              <Typography component="p">{data?.vote + " "} votes</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default GoalVideoComponent;
